import { useLingui } from "@lingui/react/macro";
import { Container } from "@mui/material";
import AppLayout from "@/components/AppLayout";
import BackToBookingButton from "@/components/BackToBookingButton";
import MarkdownDocument from "@/components/MarkdownDocument";
import deImprint from "./content/de.md?raw";
import enImprint from "./content/en.md?raw";

export default function Imprint() {
  const { i18n } = useLingui();
  const imprint = i18n.locale === "de" ? deImprint : enImprint;

  return (
    <AppLayout contentMaxWidth="md">
      <Container maxWidth="md" sx={{ py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        <BackToBookingButton />
        <MarkdownDocument>{imprint}</MarkdownDocument>
      </Container>
    </AppLayout>
  );
}
